export const slug = (input: string) => {
  let output = input
    .replaceAll(' / ', '_')
    .replaceAll(' - ', '_')
    .replaceAll(' & ', '_')
    .replaceAll(', ', '_')
    .replaceAll('-', '_')
    .replaceAll(' ', '_');
  if (output.length >= 1) {
    output = output
      .split('_')
      .map((word) => word[0].toUpperCase() + word.substring(1).toLowerCase())
      .join('');
  }
  return output;
};

export const key = (prefix: string, input: string) => {
  let output = slug(input);
  if (output.length >= 1) {
    if (
      prefix.substring(prefix.length - 1) === '.' ||
      prefix.substring(prefix.length - 1) === ':'
    ) {
      output = output[0].toLowerCase() + output.substring(1);
    }
  }
  return prefix.concat(output);
};

export const templateString = (prefix: string, input: string) => {
  let output = slug(input);
  if (output.length >= 1) {
    if (
      prefix.substring(prefix.length - 1) === '.' ||
      prefix.substring(prefix.length - 1) === ':'
    ) {
      output = output[0].toLowerCase() + output.substring(1);
    }
  }
  return prefix.concat(output) as unknown as TemplateStringsArray;
};

export const religousCapitalization = (input: string) => {
  return input
    .toLowerCase()
    .replace('bible', 'Bible')
    .replace('god', 'God')
    .replace('dios', 'Dios');
};
